import { z } from "zod/v4";
import { createEndpointBase } from "./core";
import {
  Ea4DiscoveryEnabledResponseSchema,
  Ea4DiscoveryEnvironmentResponseSchema,
  Ea4DiscoveryGetPatternsRequestSchema,
  Ea4DiscoveryGetPatternsResponseSchema,
  Ea4DiscoveryGetExecutionsRequestSchema,
  Ea4DiscoveryGetExecutionsResponseSchema,
  Ea4DiscoveryImportEventsRequestSchema,
  Ea4DiscoveryGetSessionsRequestSchema,
  Ea4DiscoveryGetSessionsResponseSchema,
  Ea4DiscoveryGetStreamUsersRequestSchema,
  Ea4DiscoveryGetStreamUsersResponseSchema,
} from "../schema/ea4d.schema";

const base = "discovery";
const ea4discovery = createEndpointBase(base);

export const ea4discoveryEndpoints = {
  ea4dGetIsEnabled: ea4discovery({
    method: "GET",
    path: "enabled",
    request: z.void(),
    response: Ea4DiscoveryEnabledResponseSchema,
    description: "Retrieves environments list from EA4 Discovery integration.",
  }),
  ea4dGetEnvironmentsList: ea4discovery({
    method: "GET",
    path: "environments",
    request: z.void(),
    response: Ea4DiscoveryEnvironmentResponseSchema,
    description: "Retrieves environments list from EA4 Discovery integration.",
  }),
  ea4dGetPatternsList: ea4discovery({
    method: "GET",
    path: "patterns",
    request: Ea4DiscoveryGetPatternsRequestSchema,
    response: Ea4DiscoveryGetPatternsResponseSchema,
    description: "Retrieves patterns list from EA4 Discovery integration for given environment.",
  }),
  ea4dGetExecutions: ea4discovery({
    method: "GET",
    path: "executions",
    request: Ea4DiscoveryGetExecutionsRequestSchema,
    response: Ea4DiscoveryGetExecutionsResponseSchema,
    description:
      "Retrieves executions list from EA4 Discovery integration for given pattern name ID.",
  }),
  ea4dImportEvents: ea4discovery({
    method: "POST",
    path: "events",
    request: Ea4DiscoveryImportEventsRequestSchema,
    response: z.any(),
    description: "Retrieves events list from EA4 Discovery integration for given execution ID.",
  }),
  ea4dGetSessions: ea4discovery({
    method: "POST",
    path: "sessions",
    request: Ea4DiscoveryGetSessionsRequestSchema,
    response: Ea4DiscoveryGetSessionsResponseSchema,
    description: "Retrieves sessions list from EA4 Discovery integration for given environment.",
  }),
  ea4dGetStreamUsers: ea4discovery({
    method: "GET",
    path: "dictionaries",
    request: Ea4DiscoveryGetStreamUsersRequestSchema,
    response: Ea4DiscoveryGetStreamUsersResponseSchema,
    description: "Retrieves from directories from EA4 Discovery integration.",
  }),
} as const;
